// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Divider, Tooltip } from 'antd';
import * as tableListSelector from 'redux/selectors/tableList';
import * as phoneBrandActions from 'redux/actions/phoneBrand';
import * as userSelector from 'redux/selectors/user';
import * as listActions from 'redux/actions/list';
import { Link } from 'react-router-dom';
import { WrapperTable } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './phoneBrandList.module.less';

const Fragment = React.Fragment;

class PhoneBrandList extends Component {
  componentWillUnmount() {
    this.props.unload();
  }

  render() {
    let tableAction = !this.props.isUserContentCreator && (
      <Fragment>
        <Link type="primary" to={'/catalog/phoneBrand/create/'}>
          <Tooltip placement="rightTop" title="Create Phone Brand">
            <FontAwesomeIcon icon="plus-square" />
          </Tooltip>
        </Link>
      </Fragment>
    );

    return (
      <div className={style.container}>
        <Row>
          <Col span={24} className={style.accountInfoButtonsContainer}>
            <WrapperTable
              title="Phone Brand List"
              filters={filters}
              columns={this.columns}
              tableAction={tableAction}
              data={this.props.listData}
              api={this.props.searchEmployees}
            />
          </Col>
        </Row>
      </div>
    );
  }
  columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      defaultSortOrder: 'DESC',
      sorter: true
    },
    {
      title: 'Short Name',
      dataIndex: 'shortName',
      sorter: true
    },
    {
      title: 'Url',
      dataIndex: 'url'
    },
    {
      title: 'Discontinued',
      dataIndex: 'discontinued',
      render: discontinued => {
        return discontinued ? 'Yes' : 'No';
      },
      sorter: true
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <Fragment>
          <Link to={`/catalog/phoneBrand/${id}/`}>view</Link>
          <Divider type="vertical" />
          {!this.props.isUserContentCreator && <Link to={`/catalog/phoneBrand/edit/${id}/`}>edit</Link>}
        </Fragment>
      )
    }
  ];
}

const filters = [
  {
    field: 'name',
    type: 'TEXT'
  },
  {
    field: 'shortName',
    type: 'TEXT'
  },
  {
    field: 'discontinued',
    type: 'YESNO'
  }
];

const mapDispatchToProps = {
  searchEmployees: phoneBrandActions.search,
  unload: listActions.listUnload
};

const mapStateToProps = (state, props) => {
  return {
    listData: tableListSelector.listData(state),
    isUserContentCreator: userSelector.isUserContentCreator(state)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhoneBrandList);
